import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../ui/dialog/dialog';
import { Observable } from 'rxjs'

import { CacheProvider } from '../../providers/cache/cache';
import { ConfigProvider } from '../../providers/config/config';
import { FileProvider } from '../../providers/file/file';
import { HelpersProvider } from '../../providers/helpers/helpers';

import { Download } from '../../providers/file/download';
import { DownloadService } from '../../providers/file/download.service';

import { environment } from '../../environments/environment';


@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {
  loading: boolean = false;
  showSession: string = '';
  showFiles: boolean = false;
  files: any = [];
  downloadBar = [];
  download$: Observable<Download>;
  API_URL = environment.API_ENV_URLS;
  block_new_users: boolean = false;
  block_new_stcoach_customers: boolean = false;
  block_new_supertreinos_web_customers: boolean = true;
  block_new_supertreinos_app_customers: boolean = false;

  constructor(
    public cacheProvider: CacheProvider,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private config: ConfigProvider,
    private file: FileProvider,
    private downloads: DownloadService,
    private helpers: HelpersProvider,
  ) {
    //
  }

  ngOnInit() {
    //

    this.config.get('block_new_users').then(
      (res: any) => {
        this.block_new_users = this.configValueToBoolean(res.value);
      },
      (err: any) => {
        console.log(err);
      });

    this.loadConfig('block_new_stcoach_customers', false, (value: boolean) => this.block_new_stcoach_customers = value);
    this.loadConfig('block_new_supertreinos_web_customers', true, (value: boolean) => this.block_new_supertreinos_web_customers = value);
    this.loadConfig('block_new_supertreinos_app_customers', false, (value: boolean) => this.block_new_supertreinos_app_customers = value);
  }

  loadConfig(configKey: string, defaultValue: boolean, assignValue: (value: boolean) => void) {
    this.config.get(configKey).then(
      (res: any) => {
        assignValue(this.configValueToBoolean(res.value, defaultValue));
      },
      (err: any) => {
        console.log(err);
      });
  }

  configValueToBoolean(value: any, defaultValue: boolean = false) {
    if (value === null || value === undefined) {
      return defaultValue;
    }

    return value === '1' || value === true;
  }


  getPremiumXLS() {
    this.downloadReport('premiumByXLS', 'usuarios-premium.csv');
  }

  getTeacherPremiumXLS() {
    this.downloadReport('premiumTeacherByXLS', 'professores-premium.csv');
  }

  getCustomersByMonthXLS() {
    this.downloadReport('customersByMonthXLS', 'novos-usuarios.csv');
  }

  getUsersByMonthXLS() {
    this.downloadReport('teachersByMonthXLS', 'novos-professores.csv');
  }

  getCancelXLS() {
    this.downloadReport('cancelByXLS', 'usuarios-cancelados.csv');
  }

  private downloadReport(report: string, filename: string) {
    this.download$ = this.downloads.download(`${this.API_URL}/data/adm/${report}`, filename);
    this.download$.subscribe(
      () => {},
      (err: any) => {
        console.log(err);
        this.toastr.error('Não foi possível gerar o relatório.', '', this.helpers.toastrCfgs);
      }
    );
  }

  delProgramsCache() {
    const msg = 'Deseja apagar o cache de servidor dos Programas?';
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: 'Apagar', message: msg, confirmation: 'Sim'}
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Sim') {
        this.cacheProvider.deleteProgramsCache().then(
          (res: any) => {
            console.log(res);
            this.toastr.success('O cache dos Programas foi apagado com sucesso!', '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.error(err.error.err, '', this.helpers.toastrCfgs);
          });
      }
    });
  }

  delLibraryCache() {
    const msg = 'Deseja apagar o cache de servidor da Biblioteca?';
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: 'Apagar', message: msg, confirmation: 'Sim'}
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Sim') {
        this.cacheProvider.deleteLibraryCache().then(
          (res: any) => {
            console.log(res);
            this.toastr.success('O cache da Biblioteca foi apagado com sucesso!', '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.error(err.error.err, '', this.helpers.toastrCfgs);
          });
      }
    });
  }

  delFoodsCache() {
    const msg = 'Deseja apagar o cache de servidor dos Alimentos?';
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: 'Apagar', message: msg, confirmation: 'Sim'}
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Sim') {
        this.cacheProvider.deleteFoodsCache().then(
          (res: any) => {
            console.log(res);
            this.toastr.success('O cache dos Alimentos foi apagado com sucesso!', '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.error(err.error.err, '', this.helpers.toastrCfgs);
          });
      }
    });
  }

  showCategories() {
    this.showSession = 'categorias';
  }

  showGoals() {
    this.showSession = 'objetivos';
  }

  showMuscles() {
    this.showSession = 'musculos';
  }

  showBkpDB() {
    this.showSession = 'backup';
    this.loading = true;
    this.file.indexDBFiles().then(
      (res: any) => {
        console.log(res);
        for (let a = 0; a < res.files.length; a++) {
          this.downloadBar[a] = this.download$;
        }
        this.files = res.files.reverse();
        this.loading = false;
      },
      (err: any) => {
        console.log(err);
        this.toastr.error('Algo deu errado', '', this.helpers.toastrCfgs);
        this.loading = false;
      }
    );
  }
  closeBkpDB() {
    this.showSession = '';
  }

  fileName(file: string) {
    return file.replace('backup/', '');
  }

  download(name: string, i: number) {
    const url = this.API_URL + '/v2/adm/dbfiles/download/' + name.replace('backup/', '');
    this.downloadBar[i] = this.downloads.download(url, name)
  }

  workoutVideos() {
    this.showSession = 'workout_videos';
  }

  migrateWorkoutVideos() {
    console.log('teste');
  }

  newUsersChange() {
    let data = (this.block_new_users) ? '1' : '0';

    if (data === '1') {
      this.toastr.warning('Fechando cadastro de Professor...', '', this.helpers.toastrCfgs);
    } else {
      this.toastr.warning('Abrindo cadastro de Professor...', '', this.helpers.toastrCfgs);
    }

    // console.log(this.block_new_users);
    // console.log(data); return false;
    this.config.set('block_new_users', data).then(
      (res: any) => {
        console.log(res);
        this.toastr.success('Configuração atualizada', '', this.helpers.toastrCfgs);
        // this.block_new_customers = res.value;
      },
      (err: any) => {
        console.log(err);
      });
  }

  newStcoachCustomersChange() {
    this.updateRegistrationConfig(
      'block_new_stcoach_customers',
      this.block_new_stcoach_customers,
      'Fechando cadastro de Alunos STCoach...',
      'Liberando cadastro de Alunos STCoach...'
    );
  }

  newSupertreinosWebCustomersChange() {
    this.updateRegistrationConfig(
      'block_new_supertreinos_web_customers',
      this.block_new_supertreinos_web_customers,
      'Fechando cadastro de Usuario SuperTreinos (web)...',
      'Liberando cadastro de Usuario SuperTreinos (web)...'
    );
  }

  newSupertreinosAppCustomersChange() {
    this.updateRegistrationConfig(
      'block_new_supertreinos_app_customers',
      this.block_new_supertreinos_app_customers,
      'Fechando cadastro de Usuario SuperTreinos (app)...',
      'Liberando cadastro de Usuario SuperTreinos (app)...'
    );
  }

  updateRegistrationConfig(configKey: string, value: any, closingMessage: string, openingMessage: string) {
    let data = (value) ? '1' : '0';

    if (data === '1') {
      this.toastr.warning(closingMessage, '', this.helpers.toastrCfgs);
    } else {
      this.toastr.warning(openingMessage, '', this.helpers.toastrCfgs);
    }

    this.config.set(configKey, data).then(
      (res: any) => {
        console.log(res);
        this.toastr.success('Configuração atualizada', '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        console.log(err);
      });
  }

}
